module.exports = function(app) {
	'use strict'
	app.directive('addApprovalDir',addApprovalDir);
	addApprovalDir.$inject=['API_URL','refreshtokenService','alertService','serverError','postDataService', 'offlineError', 'authtokenService','$rootScope','downloadPdf'];
	function addApprovalDir(API_URL,refreshtokenService, alertService,serverError, postDataService, offlineError,authtokenService, $rootScope, downloadPdf) {
		return {
			restrict: 'E',
            scope:{
				parent:'=',
                bulk:'=',
				type:'='
			},
			replace:true,
			template: require('./partial/addApproval.html'),
			link: function(scope, ele, $attrs, ctrl) {
                scope.titleRequired = false;
                if(scope.bulk) {
                    scope.ids = scope.$parent.idsForApproval
					scope.approvals = [];
                } else {
					scope.id = scope.parent._id
                    scope.ids = [scope.parent._id]
					scope.approvals = scope.parent.approvals || [];
                }
				var token = authtokenService.getToken();
				scope.dzOptionsApproval = {
			        url : API_URL + 'approvals/upload/' + scope.type,
			        paramName : 'pdf',
			        maxFilesize : '500',
			        parallelUploads: 1,
			        uploadMultiple: false,
			        acceptedFiles : '.pdf',
			        addRemoveLinks : true,
			        autoProcessQueue : false,
			        dictInvalidFileType: 'This file type is not supported.',
			        dictFileTooBig:'File size too Big',
			        dictDefaultMessage : "Drop approval pdf here to upload",
			        headers:{
			          'x-auth': token  
			        },
			        
			    };
			    scope.dzCallbacksApproval = {
			        'addedfile' : function(file){
			        	if(scope.newFileApproval) {
			        		scope.dzMethodsApproval.removeFile(scope.newFileApproval);
			        	}
                        if(scope.title) {
                            var promise = refreshtokenService.getAccessToken();
                            promise.then(
                                function(answer) {
                                    token = authtokenService.getToken();
                                    scope.dzOptionsApproval.headers['x-auth'] = token;
                                    scope.dzMethodsApproval.processQueue();
                                    scope.newFileApproval = file;
                                },
                                function(error) {
                                // report something
                                },
                                function(progress) {
                                // report progress
                            });
                        } else {
                            scope.titleRequired = true;
                            scope.dzMethodsApproval.removeFile(file);
                            alertService('danger','Opps! ', 'Approval title is required');
                        }
			        },
			        'success' : function(file, xhr, response){
			       		var data = JSON.parse(response.currentTarget.response);
			       		scope.approvals.push(data.results[0]);
			        },
			        'error' : function(file,message) {
			            // console.log(response.xhr.status);
						if(message && message.error && message.error.message) {
							jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
						}
			        },
			        'sending':function(file, xhr, formData) {
                        formData.append('document_ids', scope.ids);
                        formData.append('type', scope.type);
                        formData.append('title', scope.title);
			        }
			    };
				scope.dzMethodsApproval = {
					//   'getUploadingFiles':function(files) {
					//     console.log(files);
					// }
				};
				scope.loadUrlforDropzone = true;
                scope.removeApproval = function(approval, index) {
					$rootScope.hasLoaded = false;	
				    postDataService.save({
			          param1:'approvals',
                      param2:'remove',
			          param3:approval._id,
			        },{
			        	'document_id': scope.id,
                        'type': scope.type

			        }).$promise.then(function(data){
			        	$rootScope.hasLoaded = true;
						alertService('success','Success ', data.message, 2000);
						scope.approvals.splice(index, 1);
			        }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
			          	if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
							function(answer) {
								if(answer==200) {
								  scope.removeApproval(approval, index);
								}
							},
							function(error) {
								// report something
							},
							function(progress) {
							// report progress
							});
						} else if(error.status ==502) {
							serverError()
						} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true;
			        });
			    }
				scope.downloadApproval = downloadPdf
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/addApproval/addApprovalDirective.js
// module id = 430
// module chunks = 0